/**
 * Cart API: section rendering, add-to-cart, quantity/remove.
 * Reads section id from [data-section-id] (hidden section in DOM). Replaces all [data-cart-content].
 * Load from head with defer.
 */
(function () {
  var rootPrefix = null;
  function getRootPrefix() {
    if (rootPrefix !== null) return rootPrefix;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root != null)
      ? String(window.Shopify.routes.root).replace(/\/$/, '')
      : '';
    rootPrefix = (root ? root + '/' : '/');
    return rootPrefix;
  }
  function cartUrl(path) {
    return getRootPrefix() + path.replace(/^\//, '');
  }
  var contentContainers = null;
  var footerContainers = null;
  function getContentContainers() {
    if (contentContainers && contentContainers.length) return contentContainers;
    contentContainers = document.querySelectorAll('[data-cart-content]');
    return contentContainers;
  }
  function getFooterContainers() {
    if (footerContainers && footerContainers.length) return footerContainers;
    footerContainers = document.querySelectorAll('[data-cart-footer]');
    return footerContainers;
  }
  function invalidateCartContainerCache() {
    contentContainers = null;
    footerContainers = null;
  }

  function getSectionId() {
    var el = document.querySelector('[data-section-id]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  function getSectionContentAndFooter(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') return { content: '', footer: '' };
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlString, 'text/html');
    var section = doc.querySelector('.shopify-section') || doc.querySelector('[id^="shopify-section-"]');
    if (!section) return { content: '', footer: '' };
    var contentEl = section.querySelector('[data-cart-content]');
    var footerEl = section.querySelector('[data-cart-footer]');
    var cart = section.querySelector('.cart');
    return {
      content: contentEl ? contentEl.innerHTML : (cart ? cart.outerHTML : ''),
      footer: footerEl ? footerEl.innerHTML : ''
    };
  }

  function renderSections(parsed) {
    var sectionId = getSectionId();
    if (!parsed || !parsed.sections || !sectionId) return;
    var sectionHtml = parsed.sections[sectionId];
    if (sectionHtml == null) return;
    var parts = getSectionContentAndFooter(sectionHtml);
    if (parts.content) {
      var list = getContentContainers();
      for (var i = 0; i < list.length; i++) list[i].innerHTML = parts.content;
    }
    if (parts.footer) {
      var list = getFooterContainers();
      for (var i = 0; i < list.length; i++) list[i].innerHTML = parts.footer;
    }
    invalidateCartContainerCache();
    applyBusyStatesToDom();
    syncCountsFromDom();
    syncAllCheckoutButtons();
  }

  function updateCounts(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var countStr = String(count);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = countStr; });
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = countStr; });
    var wrapper = document.getElementById('cart-wrapper');
    if (wrapper) wrapper.setAttribute('data-count', countStr);
    var labelSource = document.querySelector('cart-drawer');
    var singular = (labelSource && labelSource.getAttribute('data-cart-label-singular')) || 'Product';
    var plural = (labelSource && labelSource.getAttribute('data-cart-label-plural')) || 'Products';
    var labelText = count === 1 ? singular : plural;
    document.querySelectorAll('[data-cart-label]').forEach(function (el) { el.textContent = labelText; });
  }

  function getCartItemCountFromDom() {
    var content = document.querySelector('[data-cart-content]');
    if (!content) return 0;
    return content.querySelectorAll('.cart-item').length;
  }

  function syncCountsFromDom() {
    updateCounts({ item_count: getCartItemCountFromDom() });
  }

  function announceToScreenReader(message) {
    var el = document.getElementById('cart-announce');
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
    if (window.cartAnnounceTimer) clearTimeout(window.cartAnnounceTimer);
    window.cartAnnounceTimer = setTimeout(function () {
      el.textContent = '';
      el.hidden = true;
      window.cartAnnounceTimer = null;
    }, 1000);
  }

  function setLoading(loading) {
    var list = getContentContainers();
    for (var i = 0; i < list.length; i++) {
      var cart = list[i].querySelector('.cart');
      if (cart) cart.classList.toggle('cart-loading', !!loading);
    }
  }

  var lineStates = Object.create(null);

  function getLineKey(item) {
    if (!item) return '';
    return item.getAttribute('data-key') || item.getAttribute('data-id') || item.getAttribute('data-line') || '';
  }

  function getLineState(key) {
    if (!key) return null;
    return lineStates[key] || null;
  }

  function setLineStateByKey(key, patch) {
    if (!key) return;
    var prev = lineStates[key] || { busy: false, updating: false, removing: false };
    var next = {
      busy: typeof patch.busy === 'boolean' ? patch.busy : prev.busy,
      updating: typeof patch.updating === 'boolean' ? patch.updating : prev.updating,
      removing: typeof patch.removing === 'boolean' ? patch.removing : prev.removing
    };
    if (!next.busy && !next.updating && !next.removing) delete lineStates[key];
    else lineStates[key] = next;
  }

  function applyBusyStateToItem(item, state) {
    if (!item) return;
    var isBusy = !!(state && state.busy);
    var isUpdating = !!(state && state.updating);
    var isRemoving = !!(state && state.removing);
    item.setAttribute('data-cart-line-busy', isBusy ? 'true' : 'false');
    item.classList.toggle('cart-item-busy', isBusy);
    item.classList.toggle('cart-item-updating', isUpdating);
    item.classList.toggle('cart-item-removing', isRemoving);
    item.querySelectorAll('.cart-quantity-btn, [data-cart-remove]').forEach(function (el) {
      if (el.tagName === 'BUTTON') el.disabled = isBusy || isUpdating;
      else {
        el.setAttribute('aria-disabled', isBusy ? 'true' : 'false');
        if (isBusy) el.setAttribute('tabindex', '-1');
        else el.removeAttribute('tabindex');
      }
    });
  }

  function applyBusyStatesToDom() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var key = getLineKey(row);
      var state = key ? getLineState(key) : null;
      applyBusyStateToItem(row, state);
    });
  }

  function isLineBusy(item) {
    var key = getLineKey(item);
    var state = key ? getLineState(key) : null;
    return !!(state && state.busy);
  }

  function setLineBusy(item, busy) {
    var key = getLineKey(item);
    if (!key) return;
    setLineStateByKey(key, { busy: !!busy });
    applyBusyStatesToDom();
  }

  function setLineUpdating(item, updating) {
    var key = getLineKey(item);
    if (!key) return;
    setLineStateByKey(key, { updating: !!updating });
    applyBusyStatesToDom();
  }

  function setLineRemoving(item, removing) {
    var key = getLineKey(item);
    if (!key) return;
    setLineStateByKey(key, { removing: !!removing });
    applyBusyStatesToDom();
  }

  function getCartDrawerMessage(key) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var attr = 'data-cart-' + key.replace(/_/g, '-');
    return drawer.getAttribute(attr);
  }

  function normalizeCartErrorMessage(err) {
    var msg = err && (err.message || err.description || (typeof err === 'string' ? err : ''));
    if (typeof msg !== 'string' || !msg) return null;
    var lower = msg.toLowerCase();
    if (lower.indexOf('maximum quantity') !== -1 || lower.indexOf('already in your cart') !== -1 ||
        lower.indexOf('quantité maximale') !== -1 || lower.indexOf('déjà dans votre panier') !== -1) {
      return getCartDrawerMessage('error_max_quantity') || msg;
    }
    if (lower.indexOf('out of stock') !== -1 || lower.indexOf('sold out') !== -1 || lower.indexOf('no longer available') !== -1 ||
        lower.indexOf('épuisé') !== -1 || lower.indexOf('rupture de stock') !== -1) {
      return getCartDrawerMessage('error_out_of_stock') || msg;
    }
    if (lower.indexOf('only') !== -1 && (lower.indexOf('available') !== -1 || lower.indexOf('left') !== -1)) {
      return getCartDrawerMessage('error_quantity_available') || msg;
    }
    if (lower.indexOf('seulement') !== -1 && lower.indexOf('disponibil') !== -1) {
      return getCartDrawerMessage('error_quantity_available') || msg;
    }
    return msg;
  }

  function showCartError(message) {
    var normalized = normalizeCartErrorMessage(message);
    var fallbackEl = document.querySelector('cart-drawer');
    var fallback = (fallbackEl && fallbackEl.getAttribute('data-cart-error-fallback')) || 'An error occurred. Please try again.';
    var text = normalized || (message && (message.message || message.description || message)) || fallback;
    if (typeof text !== 'string') text = fallback;
    document.querySelectorAll('[data-cart-error]').forEach(function (el) {
      el.textContent = text;
      el.hidden = false;
    });
    if (window.clearCartErrorTimer) clearTimeout(window.clearCartErrorTimer);
    window.clearCartErrorTimer = setTimeout(function () {
      document.querySelectorAll('[data-cart-error]').forEach(function (el) {
        el.textContent = '';
        el.hidden = true;
      });
      window.clearCartErrorTimer = null;
    }, 5000);
  }

  function parseCartResponse(res) {
    return res.text().then(function (raw) {
      var parsed = null;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        var fallbackMessage = 'Unexpected response from cart API.';
        if (res.status === 429) fallbackMessage = 'Too many requests. Please wait a moment and try again.';
        var parseErr = new Error(fallbackMessage);
        parseErr.status = res.status;
        parseErr.raw = raw;
        throw parseErr;
      }
      if (!res.ok) throw parsed;
      return parsed;
    });
  }

  function addToCart(form) {
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    var qtyEl = form.elements && form.elements['quantity'];
    var qty = (qtyEl && parseInt(qtyEl.value, 10)) || 1;
    if (!id || isNaN(id)) return Promise.reject(new Error('Missing or invalid variant id'));
    var sectionId = getSectionId();
    if (!sectionId) return Promise.reject(new Error('No section id'));
    var requestedQty = isNaN(qty) ? 1 : Math.max(1, Math.min(999, qty));
    var payload = {
      items: [{ id: id, quantity: requestedQty }],
      sections: sectionId,
      sections_url: window.location.pathname
    };
    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(parseCartResponse);
  }

  function changeLineByKey(lineKey, quantity) {
    var sectionId = getSectionId();
    if (!sectionId) return Promise.reject(new Error('No section id'));
    var payload = {
      id: lineKey,
      quantity: parseInt(quantity, 10),
      sections: sectionId,
      sections_url: window.location.pathname
    };
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(parseCartResponse);
  }

  var cartLineQueue = [];
  var queuedByLineKey = Object.create(null);
  var cartLineQueueRunning = false;

  function processCartLineQueue() {
    if (cartLineQueueRunning || !cartLineQueue.length) return;
    cartLineQueueRunning = true;
    var task = cartLineQueue.shift();
    if (!task) {
      cartLineQueueRunning = false;
      return;
    }
    delete queuedByLineKey[task.lineKey];
    Promise.resolve()
      .then(function () { return changeLineByKey(task.lineKey, task.quantity); })
      .then(function (data) {
        task.resolvers.forEach(function (resolve) { resolve(data); });
      }, function (err) {
        task.rejecters.forEach(function (reject) { reject(err); });
      })
      .then(function () {
        cartLineQueueRunning = false;
        processCartLineQueue();
      });
  }

  function enqueueCartLineChange(lineKey, quantity) {
    return new Promise(function (resolve, reject) {
      var existing = queuedByLineKey[lineKey];
      if (existing) {
        existing.quantity = quantity;
        existing.resolvers.push(resolve);
        existing.rejecters.push(reject);
      } else {
        var task = { lineKey: lineKey, quantity: quantity, resolvers: [resolve], rejecters: [reject] };
        queuedByLineKey[lineKey] = task;
        cartLineQueue.push(task);
      }
      processCartLineQueue();
    });
  }

  function refreshCartSection() {
    var sectionId = getSectionId();
    if (!sectionId) return Promise.resolve(null);
    var sectionUrl = getRootPrefix() + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(sectionUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parts = getSectionContentAndFooter(html);
        if (parts.content) {
          var list = getContentContainers();
          for (var i = 0; i < list.length; i++) list[i].innerHTML = parts.content;
        }
        if (parts.footer) {
          var list = getFooterContainers();
          for (var i = 0; i < list.length; i++) list[i].innerHTML = parts.footer;
        }
        invalidateCartContainerCache();
        applyBusyStatesToDom();
        syncCountsFromDom();
        syncAllCheckoutButtons();
        return true;
      })
      .catch(function () { return null; });
  }

  function fetchCartState() {
    return fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') === -1) return null;
        return response.json().catch(function () { return null; });
      })
      .catch(function () { return null; });
  }

  function setAddToCartButtonState(btn, state, errorMessage) {
    if (!btn) return;
    var labelTarget = btn.querySelector('.mono.extra-small-font-size') || btn;
    var defaultLabel = btn.getAttribute('data-add-to-cart-label') || 'Add to cart';
    var addingLabel = btn.getAttribute('data-adding-label') || 'Adding…';
    var addedLabel = btn.getAttribute('data-added-label') || 'Added!';
    if (state === 'adding') {
      labelTarget.textContent = addingLabel;
    } else if (state === 'added') {
      labelTarget.textContent = addedLabel;
    } else if (state === 'error' && typeof errorMessage === 'string') {
      labelTarget.textContent = errorMessage;
    } else {
      labelTarget.textContent = defaultLabel;
    }
  }

  function handleAddSubmit(e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      setAddToCartButtonState(btn, 'adding');
    }
    setLoading(true);
    addToCart(form)
      .then(function (data) {
        if (data.sections) {
          renderSections(data);
          return data;
        }
        return refreshCartSection().then(function () { return data; });
      })
      .then(function (data) {
        if (data && typeof data.item_count === 'number') {
          updateCounts(data);
        } else {
          return fetchCartState().then(function (cartData) {
            if (cartData) updateCounts(cartData);
          });
        }
      })
      .then(function () {
        setAddToCartButtonState(btn, 'added');
        announceToScreenReader('Item added to cart');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        if (window.addToCartFeedbackTimer) clearTimeout(window.addToCartFeedbackTimer);
        window.addToCartFeedbackTimer = setTimeout(function () {
          setAddToCartButtonState(btn, 'default');
          window.addToCartFeedbackTimer = null;
        }, 2000);
      })
      .catch(function (err) {
        if (console && console.error) console.error('Cart add error', err);
        showCartError(err);
        var message = normalizeCartErrorMessage(err) || (err && (err.message || err.description)) || 'An error occurred.';
        setAddToCartButtonState(btn, 'error', message);
        if (window.addToCartFeedbackTimer) clearTimeout(window.addToCartFeedbackTimer);
        window.addToCartFeedbackTimer = setTimeout(function () {
          setAddToCartButtonState(btn, 'default');
          window.addToCartFeedbackTimer = null;
        }, 2000);
      })
      .then(function () {
        setLoading(false);
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      });
  }

  function handleCartContentClick(e) {
    var content = e.target.closest('[data-cart-content]');
    if (!content) return;
    var item = e.target.closest('.cart-item');
    if (isLineBusy(item)) {
      e.preventDefault();
      return;
    }
    var lineKey = getLineKey(item);
    if (!lineKey) return;

    var isRemove = e.target.closest('[data-cart-remove]');
    if (isRemove) {
      e.preventDefault();
      setLineBusy(item, true);
      setLineRemoving(item, true);
      enqueueCartLineChange(lineKey, 0)
        .then(function (data) {
          if (data.sections) renderSections(data);
          else return refreshCartSection().then(function () { return data; });
          return data;
        })
        .then(function (data) {
          if (data && typeof data.item_count === 'number') updateCounts(data);
          else return fetchCartState().then(function (cartData) {
            if (cartData) updateCounts(cartData);
          });
        })
        .then(function () { announceToScreenReader('Item removed from cart'); })
        .catch(function (err) {
          if (console && console.error) console.error('Cart change error', err);
          showCartError(err);
        })
        .then(function () {
          setLineRemoving(item, false);
          setLineBusy(item, false);
        });
      return;
    }

    var minus = e.target.closest('.cart-quantity-btn-minus');
    var plus = e.target.closest('.cart-quantity-btn-plus');
    var qtyEl = item ? item.querySelector('.cart-quantity-value') : null;
    if (!qtyEl) return;
    var current = parseInt(qtyEl.textContent, 10) || 0;
    var next = current;
    if (minus) next = Math.max(0, current - 1);
    else if (plus) next = current + 1;
    else return;
    e.preventDefault();
    setLineBusy(item, true);
    setLineUpdating(item, true);
    enqueueCartLineChange(lineKey, next)
      .then(function (data) {
        if (data.sections) renderSections(data);
        else return refreshCartSection().then(function () { return data; });
        return data;
      })
      .then(function (data) {
        if (data && typeof data.item_count === 'number') updateCounts(data);
        else return fetchCartState().then(function (cartData) {
          if (cartData) updateCounts(cartData);
        });
      })
      .then(function () { announceToScreenReader('Cart updated'); })
      .catch(function (err) {
        if (console && console.error) console.error('Cart change error', err);
        showCartError(err);
      })
      .then(function () {
        setLineUpdating(item, false);
        setLineBusy(item, false);
      });
  }

  var cartSyncHiddenAt = null;
  var CART_SYNC_MIN_HIDDEN_MS = 2000;

  function syncCartOnVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      cartSyncHiddenAt = Date.now();
      return;
    }
    if (document.visibilityState !== 'visible') return;
    if (cartSyncHiddenAt != null && (Date.now() - cartSyncHiddenAt) < CART_SYNC_MIN_HIDDEN_MS) {
      cartSyncHiddenAt = null;
      return;
    }
    cartSyncHiddenAt = null;
    var sectionId = getSectionId();
    var sectionUrl = sectionId ? getRootPrefix() + '?section_id=' + encodeURIComponent(sectionId) : null;
    var cartPromise = fetchCartState();
    var sectionPromise = sectionUrl ? fetch(sectionUrl).then(function (r) { return r.text(); }).catch(function () { return ''; }) : Promise.resolve('');
    Promise.allSettled([cartPromise, sectionPromise])
      .then(function (results) {
        if (results[0].status === 'fulfilled' && results[0].value) updateCounts(results[0].value);
        if (results[1].status === 'fulfilled' && results[1].value) {
          var parts = getSectionContentAndFooter(results[1].value);
          if (parts.content) {
            var list = getContentContainers();
            for (var i = 0; i < list.length; i++) list[i].innerHTML = parts.content;
          }
          if (parts.footer) {
            var list = getFooterContainers();
            for (var i = 0; i < list.length; i++) list[i].innerHTML = parts.footer;
          }
          invalidateCartContainerCache();
          if (!(results[0].status === 'fulfilled' && results[0].value)) {
            syncCountsFromDom();
          }
          syncAllCheckoutButtons();
        }
      });
  }

  function updateCheckoutButtonState(checkbox) {
    if (!checkbox) return;
    var form = checkbox.closest('form');
    if (!form) return;
    var checkoutButtons = Array.prototype.slice.call(document.querySelectorAll('.cart-checkout-btn'));
    var isVisible = function (el) {
      if (!el || !el.isConnected) return false;
      if (el.hidden) return false;
      if (el.getAttribute('aria-hidden') === 'true') return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    };
    var checkoutButton = checkoutButtons.find(isVisible) || checkoutButtons[0] || null;
    if (!checkoutButton) return;
    var enabled = checkbox.checked;
    checkoutButton.removeAttribute('disabled');
    checkoutButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  }

  function syncAllCheckoutButtons() {
    document.querySelectorAll('.cart-terms-checkbox').forEach(updateCheckoutButtonState);
  }

  function getTermsCheckboxFromEventTarget(target) {
    if (!target || target.nodeType !== 1) return null;
    if (target.matches && target.matches('.cart-terms-checkbox')) return target;
    if (target.closest) return target.closest('.cart-terms-checkbox');
    return null;
  }

  function handleCartTermsToggle(e) {
    var checkbox = getTermsCheckboxFromEventTarget(e.target);
    if (!checkbox) return;
    updateCheckoutButtonState(checkbox);
  }

  document.addEventListener('submit', handleAddSubmit);
  document.addEventListener('click', handleCartContentClick);
  document.addEventListener('input', handleCartTermsToggle);
  document.addEventListener('change', handleCartTermsToggle);
  document.addEventListener('visibilitychange', syncCartOnVisibilityChange);
  syncAllCheckoutButtons();
})();